import { render, staticRenderFns } from "./file-input-tertiary.vue?vue&type=template&id=73c354b3&scoped=true"
import script from "./file-input-tertiary.vue?vue&type=script&lang=js"
export * from "./file-input-tertiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c354b3",
  null
  
)

export default component.exports